const SUPPORTED_EXTENSIONS = ["svg", "png", "jpg", "jpeg", "gif", "webp"];

export function isUrl(input: string) {
  return /^https?:\/\//i.test(input);
}

export function getExtension(input: string) {
  const clean = (input || "").trim().split("?")[0].split("#")[0];
  const lastSlash = clean.lastIndexOf("/");
  const lastDot = clean.lastIndexOf(".");

  if (lastDot === -1 || lastDot < lastSlash) return "";

  return clean.substring(lastDot + 1).toLowerCase();
}

export function isSupportedFormat(input: string) {
  const ext = getExtension(input);
  return SUPPORTED_EXTENSIONS.includes(ext);
}

export function isDataUri(input: string) {
  return /^data:image\//i.test((input || "").trim());
}

export function isRemoteWithoutExt(input: string) {
  return isUrl(input) && getExtension(input) === "";
}

type SourceInput = string | { src: string } | { uri: string } | number;
export function toWebSrc(source: SourceInput) {
  if (typeof source === "string") return { src: source.trim() };
  if (typeof source === "number") return { src: "" }; // Web doesn't support number IDs directly usually
  if (source && "src" in source)
    return { src: ((source as { src: string }).src || "").trim() };
  if (source && "uri" in source)
    return { src: ((source as { uri: string }).uri || "").trim() };
  return { src: "" };
}

export function toNativeUri(source: SourceInput) {
  if (typeof source === "number") return source;
  if (typeof source === "string") return { uri: source.trim() };
  if (source && typeof source === "object") {
    if ("uri" in source)
      return { uri: ((source as { uri: string }).uri || "").trim() };
    if ("src" in source)
      return { uri: ((source as { src: string }).src || "").trim() };
  }
  return undefined;
}

export function getBorderRadius(
  rounded?: "none" | "sm" | "md" | "lg" | "pill",
) {
  switch (rounded) {
    case "sm":
      return 4;
    case "md":
      return 8;
    case "lg":
      return 16;
    case "pill":
      return 9999;
    default:
      return 0;
  }
}

export function placeholderDataUri() {
  return "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='1' height='1'></svg>";
}
